
import {fetchAllPages} from './wordpress'

const fetchUsers = async () => {
    const users = await fetchAllPages("users");

    for (const key in users) {
        if (users.hasOwnProperty(key)) {
            const userObject = users[key];
            userObject.isAdmin = userObject.roles.includes("administrator")
            userObject.isActiveMember = userObject.roles.includes("log_active_member")
        }
    }
    return users;
}

export default fetchUsers